// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__N7pPJ","myle-emr-logo":"Logo_myle-emr-logo__Lm4nr","md":"Logo_md__XNk01"};